import { SESSION_KEY_USUARIO, SESSION_KEY_IDENTITY_DNI } from './constants-ejb';
import { UsuarioSesion } from '@model/usuario/usuario-sesion';

/**
 * Obtiene el DNI del usuario autenticado via SSO (SEUS).
 *
 * Prioridad:
 * 1. SESSION_KEY_USUARIO (sesión GIROP completa ya cargada)
 * 2. SESSION_KEY_IDENTITY_DNI (username del SSO persistido por IdentityServiceImpl)
 *
 * Si no hay sesión disponible, lanza Error — la aplicación no debe funcionar sin autenticación.
 *
 * @returns DNI del usuario (tipo + número, ej: "C43750219")
 * @throws Error si no hay sesión SSO activa
 */
export function getDniAutenticado(): string {
  // 1. Intentar obtener de la sesión GIROP (más completa)
  try {
    const cached = sessionStorage.getItem(SESSION_KEY_USUARIO);
    if (cached) {
      const usuario = JSON.parse(cached) as UsuarioSesion;
      if (usuario.dni) {
        return usuario.dni;
      }
    }
  } catch {
    // Ignorar errores de parse
  }

  // 2. Intentar obtener del username SSO (persistido por IdentityServiceImpl)
  const identityDni = sessionStorage.getItem(SESSION_KEY_IDENTITY_DNI);
  if (identityDni) {
    return identityDni;
  }

  // 3. Sin sesión SSO — no se puede operar
  throw new Error('No hay sesión SSO activa. El usuario debe autenticarse en SEUS.');
}
